'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');let

NonReentrantCommand=function(){
function NonReentrantCommand(awaitableAction,$timeout,rx){_classCallCheck(this,NonReentrantCommand);
this._awaitableAction=awaitableAction;
this._$timeout=$timeout;
this._inProgress=!1;

this._onInProgressChangedSubject=new rx.Subject;
}NonReentrantCommand.prototype.

execute=function(){var ref=_asyncToGenerator(function*(){
if(this._inProgress){
return;
}
this._inProgress=!0;
this._onInProgressChangedSubject.onNext(this._inProgress);
this._$timeout(function(){});
yield this._awaitableAction.apply(this,_.toArray(arguments));
this._inProgress=!1;
this._onInProgressChangedSubject.onNext(this._inProgress);
this._$timeout(function(){});
});function execute(){return ref.apply(this,arguments)}return execute}();_createClass(NonReentrantCommand,[{key:'inProgress',get:function()

{
return this._inProgress;
}},{key:'onInProgressChanged',get:function()

{
return this._onInProgressChangedSubject;
}}]);return NonReentrantCommand}();



module.exports=NonReentrantCommand;
//# sourceMappingURL=nonReentrantCommand.js.map
